module.exports = __webpack_public_path__ + "static/media/both-sides-arrow.cce7b97d.svg";